import { Table, Button, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import { useParams } from "react-router-dom";
import Message from "../../components/Message";
import Loader from "../../components/Loader";
import Paginate from "../../components/Paginate";
import { useGetProductsQuery, useAddProductMutation, useDeleteProductMutation } from "../../slices/productsApiSlice";
import { toast } from "react-toastify";

const ProductListScreen = () => {
  const {pageNumber} = useParams();
  
  const {data, isLoading, error, refetch} = useGetProductsQuery({pageNumber});

  const [addProduct, {isLoading: isLoadingAddProduct}] = useAddProductMutation();

  const [deleteProduct, {isLoadin: isLoadingDeleteProduct}] = useDeleteProductMutation();

  const addProductHandler = async () => {
    if (window.confirm("Confirm new product creation")) {
      try {
        await addProduct();
        refetch();
        toast.success("Product added");
      } catch (error) {
        toast.error(error?.data?.message||error.error);
      }
    }
  };

  const deleteProductHandler = async (id) => {
    if (window.confirm("Confirm product deletion")) {
      try {
        await deleteProduct(id);
        refetch();
        toast.success("Product deleted");
      } catch (error) {
        toast.error(error?.data?.message||error.error);
      }
    }
  };

  return (
    <>
      <Row className="align-items-center">
        <Col>
          <h1>Products</h1>
        </Col>
        <Col className="text-end">
          <Button className="btn-sm m-3" onClick={addProductHandler}>
            <FaPlus className="align-baseline"/> Create Product
          </Button>
        </Col>
      </Row>
      { isLoadingAddProduct && <Loader/>}
      { isLoadingDeleteProduct && <Loader/>}
      { isLoading ? <Loader/> : error ? <Message variant="danger">{error.data.message}</Message> : (
        <>  
          <Table striped hover responsive className="table-sm">
            <thead>
              <tr>
                <th>ID</th>
                <th>NAME</th>
                <th>PRICE</th>
                <th>CATEGORY</th>
                <th>SUB CATEGORY</th>
                <th>EDIT</th>
                <th>DELETE</th>
              </tr>
            </thead>
            <tbody>
              {data.products.map((product) => (
                <tr key={product._id}>
                  <td>{product._id}</td>
                  <td>{product.name}</td>
                  <td>{product.price}</td>
                  <td>{product.category}</td>
                  <td>{product.subCategory}</td>
                  <td>
                    <Link to={`/admin/product/${product._id}/edit`}>
                      <Button variant="light" className="btn-sm mx-2">
                        <FaEdit/>
                      </Button>
                    </Link>
                  </td>
                  <td>
                    <Button variant="danger" className="btn-sm" onClick={() => deleteProductHandler(product._id)}>
                      <FaTrash style={{color:"white"}}/>
                    </Button>
                  </td>
                </tr>    
              ))}
            </tbody>
          </Table>
          <Paginate
            pages={data.pages}
            page={data.page}
            isAdmin={true}/>
        </>
      )}
    </>
  )
}

export default ProductListScreen